import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { AppLoginMFAContainerModel } from "../../../../../models/aggregates/app-login/app-login-mfa-container.model";
import { HttpClient } from "@angular/common/http";
import { Core2Config } from "../shared/core2Config";

@Injectable({ providedIn: "root" })
export class AppLoginMFAService extends BaseApiTemplateService<AppLoginMFAContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-login-mfa/backoffice-ep";
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-login-mfa/backoffice-ep";
    this.httpClient = http;
  }
}